<template>
  <details :class="$style.details" ref="detailsElement">
    <summary :class="$style.details__summary">
      <IconThreeDots :class="$style.button" />
    </summary>
    <section :class="[$style.details__content, $style.menu]">
      <slot v-bind="{ closePanel }" />
    </section>
  </details>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconThreeDots from '@/components/icons/IconThreeDots.vue'

const detailsElement = ref<HTMLDetailsElement>()

const closePanel = () => {
  if (detailsElement.value) {
    detailsElement.value.open = false
  }
}
</script>

<style lang="scss" module>
.details {
  $root: &;

  display: inline-block;
  isolation: isolate;
  position: relative;

  &__summary {
    list-style: none;

    #{$root}[open] &::before {
      content: ' ';
      display: block;
      position: fixed;
      inset: 0;
      background: transparent;
    }
  }

  &__content {
    top: 24px;
    right: 0;
    position: absolute;
    isolation: isolate;
  }
}

.button {
  font-size: 20px;
  padding: 8px;
  margin: -8px;
  cursor: pointer;
}

.menu {
  display: flex;
  flex-direction: column;
  background-color: $color-surface-primary;
  border-radius: 4px;
  box-shadow: $shadow-28;
}
</style>
